import { initialState as appInitialState } from '@quiz-frontend/quiz-builder/store/app/reducer';
import { initialState as quizInitialState } from '@quiz-frontend/quiz-builder/store/quiz/reducer';
import { APP_NAME } from '@quiz-frontend/quiz-builder/types/app';
import { Action, applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk, { ThunkMiddleware } from 'redux-thunk';

import createRootReducer, { RootState } from './root-reducer';

export function initializeStore(
  initialState = {
    app: {
      ...appInitialState,
      appName: APP_NAME.Bridesmaid,
    },
    quizState: {
      ...quizInitialState,
      shouldClearOnBack: true,
    },
    sharingEmailState: {
      head: "You're invited! 💌 Check out {NAME}'s bridesmaid matches",
      body: "Hello, beautiful! I just took the bridesmaid dress quiz from David's Bridal and wanted to share the gorgeous looks. Head to my results page to see. (They have thousands of styles under $120!)\n{LINK}",
    },
  },
) {
  return createStore(
    createRootReducer(),
    initialState,
    composeWithDevTools(applyMiddleware(thunk as ThunkMiddleware<RootState, Action>)),
  );
}
